<app-header *ngIf="!onGoingPage"></app-header>
<main id="content">
  <section data-view-type="fullscreen" id="meditation-settings" *ngIf="!onGoingPage">
    <div [ngStyle]="{'background': '#464646 url(' + meditationDetailsObj.image + ')'}" class="hero hero-mediation"></div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 fullscreen-header">
          <div class="container">
            <div class="row">
              <div class="col-md-6 flex-column end text-left">
                <h1 class="heading-lg">Do a meditation</h1>
              </div>
              <div class="col-md-6 flex-column end text-right tab-align">
                <p class="text text-xl">
                  <a role="button" data-toggle="modal" data-target="#previous-meditation-modal" class="group">Previous meditation
                    <i class="fa fa-arrow-right"></i>
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 fullscreen-body desktop-show">
          <div class="container">
            <div class="row">
              <section class="col-md-6 length-section">
                <h2 class="heading-md">Choose Meditation length</h2>
                <ul class="picker">
                  <li data-action="setMeditationLength" [attr.data-choice]="index" class="btn picker-item" *ngFor="let index of meditationDetailsObj.lengths"
                    [ngClass]="{'active': index == meditationLength}" (click)=meditationLengthFn(index)>
                    <div class="val">{{index}}</div>
                    <span>min</span>
                  </li>
                </ul>
              </section>
              <section class="col-md-6 sound-section">
                <h2 class="heading-md">Background Sound</h2>
                <ul class="picker">
                  <li data-action="setBackgroundSounds" data-choice="0" class="btn picker-item" [ngClass]="{'active': backgroundSoundIndex == 0}"
                    (click)="backgroundSoundFn(0)">
                    <div class="nature">
                      <img src="/assets/images/icon_nature.svg" alt="nature">
                    </div>
                    <span>Nature</span>
                  </li>
                  <li data-action="setBackgroundSounds" data-choice="1" class="btn picker-item" [ngClass]="{'active': backgroundSoundIndex == 1}"
                    (click)="backgroundSoundFn(1)">
                    <div class="beat">
                      <img src="/assets/images/icon_beat.svg" alt="beat">
                    </div>
                    <span>Binaural Beat for Calm/Focus</span>
                  </li>
                  <li data-action="setBackgroundSounds" data-choice="2" class="btn picker-item active" [ngClass]="{'active': backgroundSoundIndex == 2}"
                    (click)="backgroundSoundFn(2)">
                    <div class="mute">
                      <img src="/assets/images/icon_mute.svg" alt="mute">
                    </div>
                    <span>None</span>
                  </li>
                </ul>
              </section>
              <section class="col-md-12 therapy-section">
                <h2 class="heading-md">Select Guided Mindfulness Therapy</h2>
                <perfect-scrollbar class="scroll-container desktop-show">
                  <ul class="picker">
                    <li data-action="setTherapy" [attr.data-meditation-id]="index.id" class="btn picker-item" *ngFor="let index of meditationAudioDetailsObj.results"
                      [ngClass]="{'active': index.id == therapyActiveNumber}" (click)="therapyNumberFn(index)">{{index.title}}</li>
                  </ul>
                </perfect-scrollbar>
              </section>
              <div class="col-md-12">
                <button (click)="startMeditation()" type="button" class="btn btn-block btn-primary btn-lg text-uppercase">start meditation</button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 mobile-show">
          <div class="container">
            <div class="row">
              <section class="col-md-6 length-section">
                <h2 class="heading-md">Choose Meditation length</h2>
                <select [(ngModel)]="meditationLength" (ngModelChange)="meditationLengthSelect($event)">
                  <option value={{index}} *ngFor="let index of meditationDetailsObj.lengths">{{index}} minutes</option>
                </select>
              </section>
              <section class="col-md-6 sound-section">
                <h2 class="heading-md">Background Sound</h2>
                <select class="text-uppercase" [(ngModel)]="backgroundSoundIndex" (ngModelChange)="bgSoundSelect($event)">
                  <option value="0">Nature</option>
                  <option value="1">Binaural Beat for Calm/Focus</option>
                  <option value="2">None</option>
                </select>
              </section>
              <section class="col-md-12 therapy-section">
                <h2 class="heading-md">Select Guided Mindfulness Therapy</h2>
                <select [(ngModel)]="therapySelectNumber" (ngModelChange)="therapySelect($event)">
                  <option value={{index.id}} *ngFor="let index of meditationAudioDetailsObj.results">{{index.title}}</option>
                </select>
              </section>
              <div class="col-md-6">
                <button (click)="startMeditation()" type="button" class="btn btn-block btn-primary btn-lg text-uppercase">start meditation</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section data-view-type="fullscreen" id="meditation" *ngIf="onGoingPage">
    <div [ngStyle]="{'background': '#464646 url(' + meditationDetailsObj.image + ')'}" class="hero hero-meditation"></div>
    <section id="meditation-info">
      <div class="text-right desktop-show">
        <div data-toggle="modal" data-target="#cancel-meditation-modal" (click)="cancelMeditation()" class="btn">stop meditation</div>
      </div>
      <div class="text-center mobile-show">
        <div data-toggle="modal" data-target="#cancel-meditation-modal" (click)="cancelMeditation()" class="cancelBtn">
          <i class="fa fa-arrow-left"></i>cancel meditation</div>
      </div>
    </section>
    <div class="player">
      <div id="meditationPlayer" class="player-container" [ngClass]="{'played': audioPlayed}">
        <div class="frame-top"></div>
        <div class="frame-bottom"></div>
        <div class="meditation-player">
          <!-- <div class="description">Your meditation will start in</div>
          <div class="counter">{{counter}}</div> -->
          <div class="description">Press play below to start meditation</div>
          <div class="player-time-indicator">
            <span class="current-time">{{audioCurrentTime}}</span>&nbsp;/&nbsp;
            <span class="duration">{{audioDuration}}</span>
          </div>
          <div data-action="setCurrentTime" class="player-progress-bar">
            <span class="progress" [style.width]="audioWidth"></span>
          </div>
          <div [attr.data-action]="audioType" class="player-btn" (click)="audioPlay()">
            <audio id="exerciseAudio" #audioOption src="{{audiosrc}}" type="audio/mp3">
            </audio>
            <audio id="bgSoundAudio" #bgSoundOption src="{{bgSoundSrc}}" type="audio/mp3">
            </audio>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
<app-menu *ngIf="!onGoingPage"></app-menu>
<div class="modal" id="previous-meditation-modal" *ngIf="!onGoingPage">
  <div class="vertical-alignment-helper">
    <div class="modal-dialog vertical-align-center">
      <div class="modal-content">
        <div class="row">
          <div class="col-md-12">
            <h1 class="heading-md">This is not enabled yet</h1>
            <button type="button" data-dismiss="modal" class="btn btn-block btn-lg btn-primary">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div id="cancel-meditation-modal" class="modal">
  <div class="vertical-alignment-helper">
    <div class="modal-dialog vertical-align-center">
      <div class="modal-content">
        <h1 class="heading-lg">Are you sure?</h1>
        <div class="buttons-wrap">
          <button (click)="navigate('/single-meditation')" class="btn btn-lg btn-danger">Yes</button>
          <button (click)="closeMeditaionModal()" class="btn btn-link">No</button>
        </div>
      </div>
    </div>
  </div>
</div>
<div id="complete-meditation-window" class="modal">
  <div class="vertical-alignment-helper">
    <div class="modal-dialog vertical-align-center">
      <div class="modal-content" [ngClass]="{'rating-modal-content': showFeedbackContent}">
        <div class="container-fluid" *ngIf="!showFeedbackContent">
          <div class="row body">
            <div class="col-md-2 text-right monk-div">
              <img src="/assets/images/monk.png" alt="monk image">
            </div>
            <div class="col-md-8">
              <h1 class="heading-lg">Good Job !</h1>
              <p class="text text-xl">Pain can be difficult to manage. Our meditation program will make it more manageable for you.</p>
            </div>
          </div>
          <div class="row footer">
            <div class="col-md-8 col-md-offset-2">
              <button (click)="navigate('/single-meditation')" class="btn btn-block btn-lg btn-primary">Do another meditation</button>
              <button (click)="navigate('/home')" class="btn btn-block btn-lg">Go to your profile</button>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="showFeedbackContent">
            <div class="col-md-12">
              <h1 class="heading-lg">What did you think about this meditation ?</h1>
              <p class="text text-md">Your opinion is very important for us, so we will really appreciate it if you could rate your satisfaction.</p>
              <div class="feedback-container desktop-show">
                <div class="wrap">
                  <div (click)="rating(1)">
                    <img src="{{smiley1}}">
                    <h4>DISLIKE</h4>
                  </div>
                  <div (click)="rating(2)">
                    <img src="{{smiley2}}">
                    <h4>OK</h4>
                  </div>
                  <div (click)="rating(3)">
                    <img src="{{smiley3}}">
                    <h4>LIKE</h4>
                  </div>
                  <div (click)="rating(4)">
                    <img src="{{smiley4}}">
                    <h4>LOVE IT</h4>
                  </div>
                </div>
                <button (click)="feedbackNotNow('no')" class="btn btn-link" *ngIf="!showFeedback">Not Now</button>
                <div class="comment" *ngIf="showFeedback">
                  <input name="feedback-comment" (ngModelChange)="onChangeFeedbackInput($event)" [(ngModel)]="feedbackBtnText" placeholder="Click here to write some details (optional)" class="input input-lg">
                  <button (click)="feedbackNotNow()" class="btn btn-lg btn-primary">Send Feedback</button>
                </div>
              </div>
              <div class="feedback-container mobile-show">
                <div class="wrap wrap-div">
                  <div (click)="rating(1)">
                    <img src="{{smiley1}}">
                    <h4>DISLIKE</h4>
                  </div>
                  <div (click)="rating(2)">
                    <img src="{{smiley2}}">
                    <h4>OK</h4>
                  </div>
                </div>
                <div class="wrap wrap-div">
                  <div (click)="rating(3)">
                    <img src="{{smiley3}}">
                    <h4>LIKE</h4>
                  </div>
                  <div (click)="rating(4)">
                    <img src="{{smiley4}}">
                    <h4>LOVE IT</h4>
                  </div>
                </div>
                <button (click)="feedbackNotNow('no')" class="btn btn-link" *ngIf="!showFeedback">Not Now</button>
                <div class="comment" *ngIf="showFeedback">
                  <input name="feedback-comment" (ngModelChange)="onChangeFeedbackInput($event)" [(ngModel)]="feedbackBtnText" placeholder="Click here to write some details (optional)" class="input input-lg">
                  <button (click)="feedbackNotNow()" class="btn btn-lg btn-primary">Send Feedback</button>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/components/meditation/meditation.component.html